import { render, staticRenderFns } from "./PreloaderComponent.vue?vue&type=template&id=24d0abfe&scoped=true&"
import script from "./PreloaderComponent.vue?vue&type=script&lang=js&"
export * from "./PreloaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderComponent.vue?vue&type=style&index=0&id=24d0abfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0abfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
